export const SET_PASSWORD = "set_password"
export const SET_PASSWORD_SUCCESSFUL = "set_password_successfull"
export const SET_PASSWORD_FAILED = "set_password_failed"
